import React, { useEffect, useRef, useState } from 'react';
import logo from '../../assets/d97ae9ac8355a0d5876385dc4a41e6c7af024c07.jpg';
import './seo.css';
import google from "../../assets/seo/google.png";
import meta from "../../assets/seo/meta.png";
import both from "../../assets/seo/bothnew.png";
import Formpage from '../Formpage/Formpage';
import Navbar from '../navbar/Navbar';
import AOS from 'aos';

import 'aos/dist/aos.css';




const invitationTypes = [
  {
    name: 'GOOGLE',
    image: google,
  },
  {
    name: 'META',
    image: meta,
  },
  {
    name: 'BOTH',
    image: both,
  },
];

function Socialmedia() {

  
    useEffect(() => {
        AOS.init({
          duration: 1000,
          once: true,
        });
    
        setTimeout(() => {
          AOS.refresh();
        }, 500);
      }, []);
  

  const [show, setShow] = useState(false);
  const handleShow = () => setShow(true);
  const handleClose = () => setShow(false);



  return (
    <>
      <Navbar />
      <div className="container-fluid web-container" >
        <div className="wrapper">
          <section className='section-margin'>
            <center>
              <div className='heading-for-all' data-aos="fade-up">
                <h2>seo</h2>
              </div>
            </center>
          </section>

          <div className="container invitation-grid" style={{
            marginTop: '4px',
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
            gap: '20px'
          }}>
            {invitationTypes.map((item, index) => (
              <div
                key={index}
                className="invitation-card"
             data-aos="fade-up"
                data-aos-delay="1000"
                style={{
                  background: '#004829',
                  padding: '30px',
                  borderRadius: '12px',
                  textAlign: 'center',
                  fontWeight: 'bold',
                  transition: '0.3s',
                  cursor: 'pointer',
                  display:'flex',
                  alignItems:'center',
                  justifyContent:'center',
                  flexDirection:'column'
                }}
                onMouseOver={e => e.currentTarget.style.background = '#fff'}
                onMouseOut={e => e.currentTarget.style.background = '#004829'}
              >
                <img    data-aos="fade-up"
                data-aos-delay="1000"
                  src={item.image}
                  alt={item.name}
                  style={{ width: '80px', height: '80px', objectFit: 'contain', marginBottom: '10px' }}
                />
                <div className='item__nameee'>{item.name}</div>
              </div>
            ))}
          </div>

        </div>

         <div
                    className="container d-flex justify-content-center my-4"
                    data-aos="fade-up"
                    data-aos-delay="1000"
                >
                    <button className="btn-15" onClick={handleShow}>
                        Get Enquiry
                    </button>
                </div>
      </div>

      <Formpage show={show} onClose={handleClose} />
    </>
  );
}

export default Socialmedia;


